
































import { Component, Prop, Vue } from 'vue-property-decorator'
import take from 'lodash/take'

const PER_PAGE = 4

@Component({})
export default class Blog extends Vue {
    posts = []

    async created() {
        const resp = await fetch(
            `https://yvivre.com/wp-json/wp/v2/posts?per_page=${PER_PAGE}`
        )
        const posts = await resp.json()

        console.log(posts)

        const _postsWithData = posts.map(async post => {
            // featuredImage
            const featuredImageID = post.featured_media
            const resp = await fetch(
                `https://yvivre.com/wp-json/wp/v2/media/${featuredImageID}`
            )
            const image = (await resp.json()) as any
            const imageURL = image.media_details.sizes['200'].source_url

            // category
            const elem = document.createElement('div')
            elem.innerHTML = post.content.rendered
            const p = elem.querySelector('.fusion-text:nth-child(2) p')
            const content = p.innerHTML
            const parts = content.split('&nbsp;')
            const category = parts[parts.length - 1]

            return {
                title: post.title.rendered,
                featuredImage: imageURL,
                link: post.link,
                category,
            }
        })
        const postsWithData = await Promise.all(_postsWithData)

        this.posts = postsWithData
    }
}
